import React from "react";

function FormContainer({ children }) {
    return (
        <div className="max-w-5xl mx-auto">{children}</div>
    );
}

export default FormContainer;